<home-carousel-view *ngIf="!communityPage && !brokeragePage && !signupPage && !keyFiguresPage"></home-carousel-view>
<div class="header-image header-image-community" *ngIf="communityPage"></div>
<div class="header-image header-image-signup" *ngIf="signupPage"></div>
<div class="header-image header-image-brokerage" *ngIf="brokeragePage"></div>
<p class="blue-label" >Digital Innovation Hub dedicated to flexible electronics technologies</p>

<router-outlet></router-outlet>
